import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tag } from 'rsuite';

export default function updateCounters(option) {
    return (
        <div>
            <div data-cy="historic-add-nbOfCounters">
                <FormattedMessage id="TCMDisplay.history.nbOfCounters" /> :{' '}
                <Tag componentClass="span" color="blue">
                    {option.length}
                </Tag>
            </div>
            <div data-cy="historic-add-nbOfCounters-name">
                {option.map(o => (
                    <Tag color="violet" key={o.label}>
                        {o.label}
                    </Tag>
                ))}
            </div>
        </div>
    );
}
